import { GET_ALL_BANNER_FAILURE, GET_ALL_BANNER_REQUEST, GET_ALL_BANNER_SUCCESS, } from "./ActionType";

const initialState = {
  designerDiscountBanners: [],
  loading: false,
  error: "",
};

export const publicDesignerDiscountBannerReducer = (state = initialState, action) => {
  switch (action.type) {

    case GET_ALL_BANNER_REQUEST:
      return { ...state, loading: true };

    case GET_ALL_BANNER_SUCCESS:
      return { ...state, loading: false, error: "", designerDiscountBanners: action.payload };

    case GET_ALL_BANNER_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
